// Common countries for shipping
export const COUNTRIES = [
  { id: "us", name: "United States" },
  { id: "ca", name: "Canada" },
  { id: "gb", name: "United Kingdom" },
  { id: "au", name: "Australia" },
  { id: "de", name: "Germany" },
  { id: "fr", name: "France" },
  { id: "jp", name: "Japan" },
  { id: "mx", name: "Mexico" },
  { id: "br", name: "Brazil" },
  { id: "es", name: "Spain" },
  { id: "it", name: "Italy" },
  { id: "nl", name: "Netherlands" },
  { id: "se", name: "Sweden" },
  { id: "no", name: "Norway" },
  { id: "dk", name: "Denmark" },
];
